import { useTelescopeContext } from "@hubble/telescope";
import { hubbleAssured } from "~/assets/assets";
import { AssuredDetailsModal } from "~/components/webstore_telescope/assured_details_modal";
import { openModalV2 } from "~/shared_states/modal";

export default function AssuredCta() {
  const { components } = useTelescopeContext();
  return (
    <div class="shadow-sm h-fit w-full cursor-pointer rounded-2xl border border-stroke-1 p-1">
      <div class=" inline-flex w-full items-end justify-between rounded-xl border border-stroke-1 bg-background-normal-primary bg-gradient-to-r from-[#30C0591A] to-[#EEFFF300] px-[22px] py-[12.5px]">
        <div>
          <div class="flex flex-row gap-0.5">
            <img
              class="anim-assured-logo h-6 w-6"
              src={hubbleAssured}
              alt="Hubble assured guarantee"
            />
            <span class="text-h5 text-success-base">Hubble assured</span>
          </div>
          <div class="text-para-3-regular text-text-normal-secondary">
            100% money back guaranteed
          </div>
        </div>
        <components.LinkButton
          text="Learn more"
          type="primary"
          underline
          size={20}
          onClick={() => {
            openModalV2(() => <AssuredDetailsModal />);
          }}
        />
      </div>
    </div>
  );
}
